<template>
  <div class="question page">
    <div class="pc-container" v-if="isPc">
      <img src="../assets/images/pc/question/01.jpg" />
      <img src="../assets/images/pc/question/02.jpg" />
      <div v-for="(image, index) in pcImages" :key="index">
        <img class="lazyload" :data-src="image" />
        <img v-if="index === 5" class="button button-left" @click="onProductionClick" src="../assets/images/pc/question/button_production.png" />
        <img v-if="index === 5" class="button button-right" @click="onDigitaClick" src="../assets/images/pc/question/button_digita.png" />
      </div>
    </div>
    <div class="mobile-container">
      <img src="../assets/images/mobile/question/01.jpg" />
      <img src="../assets/images/mobile/question/02.jpg" />
      <img src="../assets/images/mobile/question/03.jpg" />
      <div v-for="(image, index) in mobileImages" :key="index">
        <img class="lazyload" :data-src="image" />
        <img v-if="index === 4" class="button button-left" @click="onProductionClick" src="../assets/images/pc/question/button_production.png" />
        <img v-if="index === 4" class="button button-right" @click="onDigitaClick" src="../assets/images/pc/question/button_digita.png" />
      </div>
    </div>
  </div>
</template>
<script>
import { QUESTION_DIGITA_JOIN_URL, QUESTION_PRODUCTION_JOIN_URL } from '../config'
import Utils from '../utils'

export default {
  data() {
    return {
      pcImages: new Array(6).fill('').map((item, index) => {
        return require(`../assets/images/pc/question/0${index + 3}.jpg`)
      }),
      mobileImages: new Array(5).fill('').map((item, index) => {
        return require(`../assets/images/mobile/question/0${index + 4}.jpg`)
      }),
      isPc: Utils.isPc()
    }
  },
  components: {
  },
  mounted() {
    if (Utils.isPc()) {
      Utils.lazyloadImages('.pc-container .lazyload')
      setTimeout(() => {
        Utils.lazyloadImages('.mobile-container .lazyload')
      }, 1000)
      return
    }
    Utils.lazyloadImages('.mobile-container .lazyload', 50)
    setTimeout(() => {
      Utils.lazyloadImages('.pc-container .lazyload')
    }, 1000)
  },
  methods: {
    onProductionClick() {
      window.open(QUESTION_PRODUCTION_JOIN_URL)
    },
    onDigitaClick (){
      window.open(QUESTION_DIGITA_JOIN_URL)
    }
  }
}
</script>
<style>
.question{
  width: 100%;
  position: relative;
}
img{
  width: 100%;
}
.button-submit{
  width: 42.343vw;
  left: 26.64vw;
  top: 65%;
}
.button-left, .button-right{
  width: 13%;
  top: 31%;
}
.button-left{
  left: 36%;
}
.button-right{
  left: auto;
  right: 36%;
}
.mobile-container .button-left, 
.mobile-container .button-right{
  width: 36%;
  top: 34%;
  opacity: 0;
}
.mobile-container .button-left{
  left: 12%;
}
.mobile-container .button-right{
  left: auto;
  right: 12%;
}
</style>
